// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Modal,
//   TextField,
//   Box,
//   Typography,
//   Checkbox,
//   FormControlLabel,
//   FormGroup,
// } from '@mui/material';

// // Sample modal styles using Material-UI's Box
// const modalStyle = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: 400,
//   bgcolor: 'background.paper',
//   border: '2px solid #000',
//   boxShadow: 24,
//   p: 4,
// };

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const CreateGroupModal = ({ open, onClose, onGroupCreate }) => {
//   const [groupName, setGroupName] = useState('');
//   const [employees, setEmployees] = useState([]);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [error, setError] = useState(null);

//   // Fetch employees from the API
//   const fetchEmployees = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const response = await fetch(`${BASE_URL}/api/employees/`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Error fetching employees");
//       }

//       const data = await response.json();
//       setEmployees(data); // Set employees list
//     } catch (err) {
//       console.error("Error fetching employees:", err);
//       setError("Error fetching employees");
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchEmployees();
//     }
//   }, [open]);

//   // Handle checkbox selection
//   const handleCheckboxChange = (employeeId) => {
//     setSelectedEmployees((prev) =>
//       prev.includes(employeeId)
//         ? prev.filter((id) => id !== employeeId)
//         : [...prev, employeeId]
//     );
//   };


// const handleSubmit = async () => {
//     if (!groupName || selectedEmployees.length === 0) {
//       alert('Group name and at least one member are required.');
//       return;
//     }
  
//     try {
//       const token = sessionStorage.getItem('token');
//       const response = await fetch(`${BASE_URL}/api/chat/creategroup`, {
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           name: groupName,
//           members: selectedEmployees,
//         }),
//       });
  
//       // Ensure that the response is successful
//       const data = await response.json();
  
//       // Check the response status, only show success if valid
//       if (response.ok && data.status === 1) {
//         alert('Group created successfully');
//         onGroupCreate(); // Refresh groups list if needed
//         onClose(); // Close the modal
//       } else {
//         // Handle known failure cases (like status not being 1)
//         alert('Failed to create group');
//       }
//     } catch (err) {
//       // Only catch network or unexpected errors here
//       console.error('Error creating group:', err);
//     }
//   };
  

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={modalStyle}>
//         <Typography variant="h6" component="h2">
//           Create New Group
//         </Typography>
//         <TextField
//           fullWidth
//           label="Group Name"
//           variant="outlined"
//           margin="normal"
//           value={groupName}
//           onChange={(e) => setGroupName(e.target.value)}
//         />
//         <Typography variant="subtitle1" component="p" sx={{ mt: 2 }}>
//           Select Members:
//         </Typography>
//         <Box
//           sx={{
//             maxHeight: 200, // Set a maximum height
//             overflowY: 'auto', // Enable vertical scrolling
//             border: '1px solid #ccc', // Optional border for visual clarity
//             padding: '10px', // Optional padding
//             mt: 1,
//           }}
//         >
//           <FormGroup>
//             {employees.length > 0 &&
//               employees.map((employee) => (
//                 <FormControlLabel
//                   key={employee._id}
//                   control={
//                     <Checkbox
//                       checked={selectedEmployees.includes(employee._id)}
//                       onChange={() => handleCheckboxChange(employee._id)}
//                     />
//                   }
//                   label={employee.name} // Assuming employee has a 'name' field
//                 />
//               ))}
//           </FormGroup>
//         </Box>
//         <Button
//           variant="contained"
//           color="primary"
//           sx={{ mt: 2 }}
//           onClick={handleSubmit}
//         >
//           Create Group
//         </Button>
//         {error && <Typography color="error">{error}</Typography>}
//       </Box>
//     </Modal>
//   );
// };

// export default CreateGroupModal;



// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Modal,
//   TextField,
//   Box,
//   Typography,
//   Checkbox,
//   FormControlLabel,
//   FormGroup,
//   IconButton, // Import IconButton
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon

// // Sample modal styles using Material-UI's Box
// const modalStyle = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: 400,
//   bgcolor: 'background.paper',
//   border: '2px solid #000',
//   boxShadow: 24,
//   p: 4,
// };

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const CreateGroupModal = ({ open, onClose, onGroupCreate }) => {
//   const [groupName, setGroupName] = useState('');
//   const [employees, setEmployees] = useState([]);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [error, setError] = useState(null);

//   // Fetch employees from the API
//   const fetchEmployees = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const response = await fetch(`${BASE_URL}/api/employees/`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Error fetching employees");
//       }

//       const data = await response.json();
//       setEmployees(data); // Set employees list
//     } catch (err) {
//       console.error("Error fetching employees:", err);
//       setError("Error fetching employees");
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchEmployees();
//     }
//   }, [open]);

//   // Handle checkbox selection
//   const handleCheckboxChange = (employeeId) => {
//     setSelectedEmployees((prev) =>
//       prev.includes(employeeId)
//         ? prev.filter((id) => id !== employeeId)
//         : [...prev, employeeId]
//     );
//   };

//   const handleSubmit = async () => {
//     if (!groupName || selectedEmployees.length === 0) {
//       alert('Group name and at least one member are required.');
//       return;
//     }

//     try {
//       const token = sessionStorage.getItem('token');
//       const response = await fetch(`${BASE_URL}/api/chat/creategroup`, {
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           name: groupName,
//           members: selectedEmployees,
//         }),
//       });

//       // Ensure that the response is successful
//       const data = await response.json();

//       // Check the response status, only show success if valid
//       if (response.ok && data.status === 1) {
//         alert('Group created successfully');
//         onGroupCreate(); // Refresh groups list if needed
//         onClose(); // Close the modal
//       } else {
//         // Handle known failure cases (like status not being 1)
//         alert('Failed to create group');
//       }
//     } catch (err) {
//       // Only catch network or unexpected errors here
//       console.error('Error creating group:', err);
//     }
//   };

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={modalStyle}>
//         {/* Close Icon added here */}
//         <IconButton
//           edge="end"
//           color="inherit"
//           onClick={onClose}
//           sx={{ position: 'absolute', top: 10, right: 10 }}
//         >
//           <CloseIcon />
//         </IconButton>

//         <Typography variant="h6" component="h2">
//           Create New Group
//         </Typography>
//         <TextField
//           fullWidth
//           label="Group Name"
//           variant="outlined"
//           margin="normal"
//           value={groupName}
//           onChange={(e) => setGroupName(e.target.value)}
//         />
//         <Typography variant="subtitle1" component="p" sx={{ mt: 2 }}>
//           Select Members:
//         </Typography>
//         <Box
//           sx={{
//             maxHeight: 200, // Set a maximum height
//             overflowY: 'auto', // Enable vertical scrolling
//             border: '1px solid #ccc', // Optional border for visual clarity
//             padding: '10px', // Optional padding
//             mt: 1,
//           }}
//         >
//           <FormGroup>
//             {employees.length > 0 &&
//               employees.map((employee) => (
//                 <FormControlLabel
//                   key={employee._id}
//                   control={
//                     <Checkbox
//                       checked={selectedEmployees.includes(employee._id)}
//                       onChange={() => handleCheckboxChange(employee._id)}
//                     />
//                   }
//                   label={employee.name} // Assuming employee has a 'name' field
//                 />
//               ))}
//           </FormGroup>
//         </Box>
//         <Button
//           variant="contained"
//           color="primary"
//           sx={{ mt: 2 }}
//           onClick={handleSubmit}
//         >
//           Create Group
//         </Button>
//         {error && <Typography color="error">{error}</Typography>}
//       </Box>
//     </Modal>
//   );
// };

// export default CreateGroupModal;












import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  TextField,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Updated modal styles
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh',
  display: 'flex',
  flexDirection: 'column',
};

const BASE_URL = process.env.REACT_APP_BASE_URL;

const CreateGroupModal = ({ open, onClose, onGroupCreate }) => {
  const [groupName, setGroupName] = useState('');
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [error, setError] = useState(null);

  // Fetch employees from the API
  const fetchEmployees = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}/api/employees/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Error fetching employees");

      const data = await response.json();
      setEmployees(data);
    } catch (err) {
      console.error("Error fetching employees:", err);
      setError("Error fetching employees");
    }
  };

  useEffect(() => {
    if (open) fetchEmployees();
  }, [open]);

  // Handle checkbox selection
  const handleCheckboxChange = (employeeId) => {
    setSelectedEmployees((prev) =>
      prev.includes(employeeId)
        ? prev.filter((id) => id !== employeeId)
        : [...prev, employeeId]
    );
  };

  const handleSubmit = async () => {
    if (!groupName || selectedEmployees.length === 0) {
      alert('Group name and at least one member are required.');
      return;
    }

    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${BASE_URL}/api/chat/creategroup`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: groupName,
          members: selectedEmployees,
        }),
      });

      const data = await response.json();

      if (response.ok && data.status === 1) {
        alert('Group created successfully');
        onGroupCreate();
        onClose();
      } else {
        alert('Failed to create group');
      }
    } catch (err) {
      console.error('Error creating group:', err);
    }
  };

  return (
<Modal open={open} onClose={onClose}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 480,
      bgcolor: '#ffffff',
      borderRadius: '16px', // rounded corners
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)', // smooth shadow
      p: 4,
      maxHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Header */}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6" fontWeight="bold">
        Create New Group
      </Typography>
      {/* <IconButton
        onClick={onClose}
        disableRipple
        sx={{
          p: 0.5,
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton> */}
    </Box>

    <Divider sx={{ mb: 2 }} />

    {/* Group Name Input */}
    <TextField
      fullWidth
      label="Group Name"
      variant="outlined"
      value={groupName}
      onChange={(e) => setGroupName(e.target.value)}
      sx={{
        mb: 3,
        '& .MuiOutlinedInput-root': { borderRadius: '12px' },
      }}
    />

    {/* Member Selection */}
    <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 1 }}>
      Select Members
    </Typography>
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        p: 1.5,
        mb: 3,
        backgroundColor: '#f9fafc',
        boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
      }}
    >
      <FormGroup>
        {employees.length > 0 ? (
          employees.map((employee) => (
            <FormControlLabel
              key={employee._id}
              control={
                <Checkbox
                  checked={selectedEmployees.includes(employee._id)}
                  onChange={() => handleCheckboxChange(employee._id)}
                  color="primary"
                />
              }
              label={employee.name}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            {error || "No employees available"}
          </Typography>
        )}
      </FormGroup>
    </Box>

    {/* Footer Actions */}
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
  <Button
  onClick={onClose}
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: 500,
    color: '#111827',
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    textTransform: 'none',
    height: '44px',
    position: 'relative', // needed for wave
    overflow: 'hidden',   // keep wave inside
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#f9fafb',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
    },
  }}
  onMouseOver={(e) => {
    const wave = e.currentTarget.querySelector('.hover-wave');
    if (wave) wave.style.left = '100%';
  }}
  onMouseOut={(e) => {
    const wave = e.currentTarget.querySelector('.hover-wave');
    if (wave) wave.style.left = '-100%';
  }}
>
  Cancel
  <span
    className="hover-wave"
    style={{
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.05)', // subtle wave color for light button
      transform: 'skewX(-20deg)',
      transition: 'left 0.6s ease-in-out',
      pointerEvents: 'none',
    }}
  />
</Button>


   <Button
  onClick={handleSubmit}
  sx={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: 500,
    color: "#ffffff",
    backgroundColor: "#2563eb", // Tailwind blue-600
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
    transition: "all 0.3s ease",
    textTransform: "none",
    height: "44px",
    overflow: "hidden", // needed for wave
    position: "relative",
    "&:hover": {
      backgroundColor: "#1e40af", // blue-800
      boxShadow: "0 6px 14px rgba(0, 0, 0, 0.2)",
    },
    "&.Mui-disabled": {
      opacity: 0.7,
      cursor: "not-allowed",
      backgroundColor: "#2563eb",
    },
  }}
  onMouseOver={(e) => {
    const wave = e.currentTarget.querySelector(".hover-wave");
    if (wave) wave.style.left = "100%";
  }}
  onMouseOut={(e) => {
    const wave = e.currentTarget.querySelector(".hover-wave");
    if (wave) wave.style.left = "-100%";
  }}
>
  Create Group
  <span
    className="hover-wave"
    style={{
      position: "absolute",
      top: 0,
      left: "-100%",
      width: "100%",
      height: "100%",
      background: "rgba(255,255,255,0.25)",
      transform: "skewX(-20deg)",
      transition: "left 0.6s ease-in-out",
      pointerEvents: "none",
      borderRadius: "12px",
    }}
  />
</Button>

    </Box>
  </Box>
</Modal>

  );
};

export default CreateGroupModal;
